"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTripVehicle = exports.vehicleLabels = exports.allValidVehicles = exports.isValidVehicle = exports.isVehicle = void 0;
var prisma_1 = require("@ambler/prisma");
var isVehicle = function (vehicle) { return vehicle in prisma_1.Vehicle; };
exports.isVehicle = isVehicle;
var isValidVehicle = function (vehicle) { return vehicle !== 'TPS'; };
exports.isValidVehicle = isValidVehicle;
exports.allValidVehicles = Object.values(prisma_1.Vehicle).filter(exports.isValidVehicle);
exports.vehicleLabels = {
    AMBULANCE: 'Ambulance',
    VSL: 'VSL',
    TAXI: 'Taxi',
    TPS: 'TPS',
    BARIATRIC: 'Bariatrique',
    TPMR: 'TPMR',
    PARAMEDICAL: 'Ambulance paramédicalisée',
    MEDICAL: 'Ambulance médicalisée',
    VP: 'Véhicule personnel',
    TC: 'Transport en commun',
    TAP: 'TAP',
};
var formatTripVehicle = function (_a) {
    var assignedVehicle = _a.assignedVehicle, requestedVehicle = _a.requestedVehicle;
    if (!assignedVehicle && !requestedVehicle) {
        throw Error('We need assignedVehicle or requestedVehicle');
    }
    if (assignedVehicle) {
        return exports.vehicleLabels[assignedVehicle];
    }
    if (requestedVehicle === 'VSL') {
        return 'TAP';
    }
    return exports.vehicleLabels[requestedVehicle];
};
exports.formatTripVehicle = formatTripVehicle;
//# sourceMappingURL=vehicle.js.map